import {configureStore} from "@reduxjs/toolkit";
import { authReducer } from "./slices/authSlice";
import { profileReducer } from "./slices/profileSlice";
import { attendanceReducer } from "./slices/attendanceSlice";
import { passwordReducer } from "./slices/passwordSlice";
import { dailyUpdateReducer } from "./slices/dailyUpdateSlice";


const store  = configureStore({
    reducer:{

        auth: authReducer,
        profile: profileReducer,
        attendance: attendanceReducer,
        password: passwordReducer,
        dailyUpdate: dailyUpdateReducer,


    }
});

export default store;